import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "d-flex flex-column" };
const _hoisted_2 = { class: "form-setting-container" };
const _hoisted_3 = { class: "d-flex flex-column" };
const _hoisted_4 = { class: "d-flex align-items-center form-setting--title" };
const _hoisted_5 = { class: "v2-text--base-2" };
const _hoisted_6 = { class: "form-setting--input d-flex justify-content-end" };
const _hoisted_7 = {
    key: 0,
    class: "form-setting--description v2-text--small text-v2-secondary mt-tiny-2"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'form-setting',
    props: {
        title: {},
        description: { default: null }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, [
                                _renderSlot(_ctx.$slots, "title", { title: __props.title }, () => [
                                    _createElementVNode("span", null, _toDisplayString(__props.title), 1)
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ]),
                (__props.description)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.description), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
